export const homeContent = {
  hero: {
    availability: 'Open to contract & fractional work',
    title: "Hi, I'm Clinton — I build things that ship.",
    lede: "A software engineer of eight years and founder of Veraclins Tech Solutions. I help teams turn fuzzy problems into reliable, well-built products — across healthcare, eCommerce and enterprise SaaS — and I'm genuinely good to work with.",
    primaryCta: {
      label: 'See my work',
      href: '/work',
    },
    secondaryCta: {
      label: 'About me',
      href: '/about',
    },
    monogram: 'CA',
  },
  stats: [
    {
      value: '8 yrs',
      label: 'building for production',
    },
    {
      value: '10+',
      label: 'engineers mentored',
    },
    {
      value: '5',
      label: 'companies & my own studio',
    },
    {
      value: '12+',
      label: 'packages in my Nx monorepo',
    },
  ],
  featured: {
    title: "A few things I've built",
    subtitle: 'From enterprise platforms to my own products.',
    allLabel: 'All work',
    allHref: '/work',
    items: [
      {
        tag: 'Enterprise',
        title: 'ValueBlue',
        description:
          'A BPMN 2.0 modeling editor built from scratch, plus the AI assistant UI for an enterprise SaaS.',
        href: '/work/valueblue',
        cta: 'Read case study',
      },
      {
        tag: 'Healthcare',
        title: 'Ishi Health',
        description:
          'A zero-downtime database migration and a 3× faster app for a healthcare platform.',
        href: '/work/ishi-health',
        cta: 'Read case study',
      },
    ],
    products: {
      tag: 'Products',
      title: 'My own products',
      description:
        'edulinks.ng, valideate and pitch-prophet — designed, built and shipped end to end.',
      href: '/work',
      cta: 'Explore all',
    },
  },
  about: {
    eyebrow: 'A little about me',
    heading: 'I like the unglamorous parts that make software good.',
    body: "Performance budgets, accessible UI, clean data layers, migrations that don't lose data. I've shipped enterprise process-modeling tools, led a healthcare platform migration, and built eCommerce systems serving millions of customers a year — and I build @veraclins-dev, an in-house platform of UI, editor, forms, SEO, auth and framework-agnostic tooling that my own products run on.",
    cta: 'More about how I work',
    href: '/about',
  },
} as const;
